enum FileModule {
  Departure = 'Departures',
  Arrival = 'Arrivals',
  Commercial = 'Commercial',
}

export default FileModule;
